import { CompactNumber } from "@/shared/ui/CompactNumber";
import { Card, CardContent } from "@/components/ui/card";
import {
  CheckCircle2Icon,
  ClipboardListIcon,
  LayersIcon,
} from "lucide-react";

type TopupQueueSummaryCardsProps = {
  queueHealth: number;
  todaysApprovals: number;
  totalProcessed: number;
  isLoading?: boolean;
};

export function TopupQueueSummaryCards({
  queueHealth,
  todaysApprovals,
  totalProcessed,
  isLoading,
}: TopupQueueSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="rounded-xl border bg-card">
            <CardContent>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <Card className="rounded-xl border border-amber-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
            <ClipboardListIcon className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ສລິບໂອນລໍຖ້າອະນຸມັດ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={queueHealth} />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-emerald-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10">
            <CheckCircle2Icon className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ອະນຸມັດມື້ນີ້
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={todaysApprovals} />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-blue-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-500/10">
            <LayersIcon className="size-5 text-blue-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ປະມວນທັງໝົດ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={totalProcessed} />
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
